import { guid } from "@common/Guid";
import { logInfo } from "@common/Logger";
import { ValidationError } from "@common/types";
import { Vue } from 'vue-facing-decorator';
import { Component } from 'vue-facing-decorator';
import * as cqrs from "@cqrs/cqrs";

@Component
export default class VueCqrs extends Vue {
    model: any = {};
    validationErrors: ValidationError[] = [];

    onCommand(cmd: any, correlationId: string | null) { return cmd; }
    onCommandInvoked(cmd: any, correlationId: string | null) { }
    onCommandSucceed(cmd: any, correlationId: string | null, result: any) { }
    onCommandFailed(status: cqrs.ICommandStatus) { }
    onSetQueryError(query: any, err: string | null) { }

    onSetQueryStatus(status: cqrs.IQueryStatus) {
        if (status.Success && status.Auth) {
            if (this.onSetModel) {
                this.onSetModel(status.Model, status.ModelName);
            }
        }
        else if (status.Auth === false) {
            if (status.RedirectUrl) {
                location.href = status.RedirectUrl;
            }
            else {
                location.href = '/#/signin';
            }
        }
        else {
            if (this.onSetQueryError) {
                this.onSetQueryError(status.Query, status.Error);
            }
        }
    }

    onSetModel(model: any, modelName: string) {
        if (modelName == "Auth") {
            if (!model) {
                this.$router.push('/signin')
            }
        }
        if (this.model) {
            const simplifiedModelName = modelName.replace('ReadModel', '');
            this.model[simplifiedModelName] = model;
            logInfo(`Model '${simplifiedModelName}' was set`);
            logInfo(model);
        }
    }

    onSetCommandStatus(status: cqrs.ICommandStatus) {
        if (status.Success) {
            if (this.onCommandSucceed) {
                this.onCommandSucceed(status.Command, status.CorrelationId, status.Result);
                logInfo(`Command '${status.Command.$type}' succeed`);
                logInfo(status);
            }
        }
        else {
            if (this.onCommandFailed) {
                this.onCommandFailed(status);
                logInfo(`Command '${status.Command.$type}' failed`);
                logInfo(status);
            }
        }
    }

    $clearValidationErrors() {
        this.validationErrors.splice(0);
    }

    $pushValidationErrors(errors: ValidationError[]) {
        this.validationErrors.push(...errors);
    }

    $query(query: any, correlationId = guid()) {
        cqrs.query(query, correlationId);
    }

    $command(cmd: any, correlationId: string | null = null) {
        cmd = this.onCommand(cmd, correlationId);
        this.onCommandInvoked(cmd, correlationId);
        cqrs.command(cmd, correlationId);
    }

    beforeUnmount() {
        cqrs.unsubscribeSetQueryStatus(this.onSetQueryStatus);
        cqrs.unsubscribeSetCommandStatus(this.onSetCommandStatus);
    }

    mounted() {
        cqrs.subscribeSetQueryStatus(this.onSetQueryStatus);
        cqrs.subscribeSetCommandStatus(this.onSetCommandStatus);
    }
}